import React from 'react';
import DisplayRendering from "../DisplayRendering";
import {withFormikFormControl} from "../FormikFormControl";
import {extract} from "../utils";

export const FormButton = (props) => {
  console.log('Form Button Display', props)
  return <DisplayRendering {...props} />
};

export default withFormikFormControl()(FormButton);
